export default function MovieViewFallback() {
  return (
    <div className="my-6 lg:my-16 m-auto px-0 lg:px-4 xxl:px-10 ">
      <div className="aspect-video">
        <div className="relative h-full bg-grey50 animate-pulse "></div>
      </div>
    </div>
  );
}
